/**
 * Konfiguracja resource
 *
 * @export
 * @class ResourceConfig
 */
export class ResourceConfig {
    /**
     * Ustawia nowego klienta apollo
     *
     * @static
     * @param {ApolloClient<any>} apollo
     * @memberof ResourceConfig
     */
    static setApollo(apollo) {
        this.apollo = apollo;
    }
    /**
     * Ustawia nowy loader
     *
     * @static
     * @param {Loader} loader
     * @memberof ResourceConfig
     */
    static setLoader(loader) {
        this.loader = loader;
    }
}
/**
 * URL api map
 *
 * @type {string}
 * @memberof Config
 */
ResourceConfig.mapsURL = process.env.VUE_APP_MAPS_URL || '';
//# sourceMappingURL=resourceConfig.js.map